import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.3 } }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const ContactSection = () => {
  return (
    <motion.section 
      className="contact-section"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <h2 className="bg-title">تواصل معنا</h2>

      <motion.h2 className="top-title" variants={itemVariants}>
        تواصل معنا
      </motion.h2>

      <div className="contact-container">
        <motion.div className="contact-box" variants={itemVariants} whileHover={{ y: -15 }}>
          <h4>تابعنا</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/18pYfJj69D/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://wa.me/201289068928" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp"></i></a>
            <a href="https://www.instagram.com/mamy_brand_4?igsh=bTY4eXV0ajNwbDJn&utm_source=qr" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://www.tiktok.com/@mamy.brand3" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
          </div>
        </motion.div>

        <motion.div className="contact-main" variants={itemVariants}>
          <h3>جاهز لتبدأ مشروعك القادم؟</h3>
          <p>نحن هنا لنحول رؤيتك إلى واقع رقمي مذهل.</p>
         <a 
  href="https://wa.me/201278922244" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="cta-btn"
>
  ابدأ الآن
</a> 
        </motion.div>

        <motion.div className="contact-box" variants={itemVariants} whileHover={{ y: -15 }}>
          <h4>بيانات الاتصال</h4>
          <p><i className="fas fa-phone"></i> 01278922244  </p>
          <p><i className="fas fa-envelope"></i>mamybrand4@gmail.com</p>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default ContactSection;